import React, { useEffect, useState } from "react";
import { Button, Header, Heading, MainContainer } from "../../globalStyles";
import {
  FormContainer,
  Input,
  InputContainer,
  ConfirmContainer,
  Wrapper,
  InputLabel,
  Error,
  LabelBlock,
  InputBlock,
  MobileLabel,
} from "./confirmPassStyle";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
const ConfirmPass = () => {
  const [password, setPassword] = useState("");
  const [cPassword, setCPassword] = useState("");
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [isCPasswordDirty, setIsCPasswordDirty] = useState(false);
  const [isDisable, setDisable] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isFetching, error, resetData } = useSelector((state) => state.reset);
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(password, "password");
    console.log(cPassword, "cPassword");
    // resetPassData(dispatch, { email });
  };
  // useEffect(() => {
  //   if (password && cPassword) {
  //     setTimeout(() => {
  //       navigate("/atf-dashboard");
  //     }, 800);
  //   }
  // }, [cPassword]);

  useEffect(() => {
    if (isCPasswordDirty) {
      if (password === cPassword) {
        setShowErrorMessage(false);
        console.log("match");
        setDisable(true);
      } else {
        setShowErrorMessage(true);
        console.log("not match");
        setDisable(false);
      }
    }
  }, [cPassword]);
  const handleCPassword = (e) => {
    setCPassword(e.target.value);
    setIsCPasswordDirty(true);
    console.log("Handle Password");
  };

  return (
    <>
      <MainContainer
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          paddingTop: "80px",
        }}
      >
        <ConfirmContainer>
          <Header>
            <Heading>Set Password</Heading>
          </Header>

          <Wrapper>
            <form onSubmit={handleSubmit}>
              <FormContainer>
                <InputContainer>
                  <LabelBlock>
                    <InputLabel>Password</InputLabel>
                    <InputLabel>Confirm Password</InputLabel>
                  </LabelBlock>

                  <InputBlock>
                    <MobileLabel>Password</MobileLabel>
                    <Input
                      name="password"
                      required="true"
                      type="password"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                    <MobileLabel>Confirm Password</MobileLabel>
                    <Input
                      name="cPassword"
                      required="true"
                      type="password"
                      value={cPassword}
                      onChange={handleCPassword}
                    />
                  </InputBlock>
                </InputContainer>
                {showErrorMessage && isCPasswordDirty ? (
                  <Error> Passwords did not match </Error>
                ) : (
                  ""
                )}
                {isDisable === false ? (
                  <Button disabled className="resetButton" variant="dim">
                    Save
                  </Button>
                ) : (
                  <Button type="submit" className="resetButton">
                    Save
                  </Button>
                )}
              </FormContainer>
            </form>
          </Wrapper>
        </ConfirmContainer>
        <ToastContainer position="bottom-right" newestOnTop />
      </MainContainer>
    </>
  );
};

export default ConfirmPass;
